import Region from '../../../../../../constants/region';
import { getUserRegion } from '../../../../../../../utils';
import caciqueConfig from './cacique-creation-menu-config';
import defaultConfig from './default-creation-menu-config';
import legacyConfig from './legacy-creation-menu-config';
import mmpaConfig from './mmpa-creation-menu-config';
import nlConfig from './nl-creation-menu-config';
import prairieConfig from './prairie-creation-menu-config';
import tcjConfig from './tcj-creation-menu-config';
import udaConfig from './uda-creation-menu-config';
import uncConfig from './unc-creation-menu-config';

const navigationConfigs = {
    [Region.CACIQUE]: caciqueConfig,
    [Region.LEGACY]: legacyConfig,
    [Region.MMPA]: mmpaConfig,
    [Region.NL]: nlConfig,
    [Region.PRAIRIE]: prairieConfig,
    [Region.TCJ.NEBRASKA]: tcjConfig,
    [Region.TCJ.LIBERTY]: tcjConfig,
    [Region.TCJ.WHITEEAGLE]: tcjConfig,
    [Region.TCJ.ERIE]: tcjConfig,
    [Region.TCJ.KYTN]: tcjConfig,
    [Region.TCJ.GPDA]: tcjConfig,
    [Region.UDA]: udaConfig,
    [Region.UNC]: uncConfig,
};

const getCreationMenuConfig = () => {
    const region = getUserRegion();
    return Object.values(navigationConfigs[region] ?? defaultConfig);
};

export default getCreationMenuConfig;
